document.addEventListener('DOMContentLoaded', function () {
  const quizOptions = document.querySelectorAll('.quiz-option');
  const groundBeansButton = document.querySelector('.quiz-btn[data-answer="ground-beans"]');
 
  quizOptions.forEach(option => {
    option.addEventListener('click', function () {
      const nextQuestion = this.getAttribute('data-next');

      // If Decafe option is selected, redirect
      if (nextQuestion === 'decafe-redirect') {
        
        const grinderQuestionElement = document.querySelector('.quiz-question[data-question="decafe-beans-products"]');
        if (grinderQuestionElement) {
          grinderQuestionElement.style.display = 'flex';
        }
      }

      // Hide the current question
      const currentQuestion = this.closest('.quiz-question');
      currentQuestion.style.display = 'none';

      // Show the next question or product list
      const nextQuestionElement = document.querySelector(`.quiz-question[data-question="${nextQuestion}"]`);
      const productContainer = document.querySelector(`.product-container[data-products="${nextQuestion}"]`);

      if (nextQuestionElement) {
        nextQuestionElement.style.display = 'flex';
      } else if (productContainer) {
        productContainer.style.display = 'flex';
      } else {
        console.error('Next step not found for:', nextQuestion);
      }

      // If ground beans option is selected, show grinder question
      if (this.getAttribute('data-answer') === 'ground-beans') {
        const grinderQuestionElement = document.querySelector('.quiz-question[data-question="grinder"]');
        if (grinderQuestionElement) {
          grinderQuestionElement.style.display = 'flex';
        }
      }
      if (this.getAttribute('data-answer') === 'yes') {
        const coffeeStrengthQuestionElement = document.querySelector('.quiz-question[data-question="2"]');
        if (coffeeStrengthQuestionElement) {
          coffeeStrengthQuestionElement.style.display = 'flex';
        }
      }

      // Show the filter question if 'filter' option is selected
      if (this.getAttribute('data-answer') === 'filter') {
        const filterQuestionElement = document.querySelector('.quiz-question[data-question="filter"]');
        if (filterQuestionElement) {
          filterQuestionElement.style.display = 'flex';
        }
      }
      
       if (this.getAttribute('data-answer') === 'grinder-advantages') {
        const filterQuestionElement = document.querySelector('.quiz-question[data-question="grinder-advantages"]');
        if (filterQuestionElement) {
          filterQuestionElement.style.display = 'flex';
        }
      }
       if (this.getAttribute('data-answer') === 'ground-beans-products') {
        const filterQuestionElement = document.querySelector('.quiz-question[data-question="ground-beans-products"]');
        if (filterQuestionElement) {
          filterQuestionElement.style.display = 'flex';
        }
      }
      if (this.getAttribute('data-answer') === 'continue-quiz') {
        const coffeeStrengthQuestionElement = document.querySelector('.quiz-question[data-question="2"]');
        if (coffeeStrengthQuestionElement) {
          coffeeStrengthQuestionElement.style.display = 'flex';
        }
      }
      if (this.getAttribute('data-answer') === 'cups') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="cups-page"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
       if (this.getAttribute('data-answer') === 'yes-cups') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="cup-grinder-question"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
      if (this.getAttribute('data-answer') === 'yes-to-beans') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="2"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
      
      if (this.getAttribute('data-answer') === 'no-to-beans-grinder') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="no-action"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
        if (this.getAttribute('data-answer') === 'no-cup') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="no-cups"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
       if (this.getAttribute('data-answer') === 'show-cups-product') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="show-cups-product"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
     
       if (this.getAttribute('data-answer') === 'show-cups-advantages') {
          const cupsQuestionElement = document.querySelector('.quiz-question[data-question="show-cups-advantages"]');
          if (cupsQuestionElement) {
            cupsQuestionElement.style.display = 'flex';
          }
        }
      if (this.getAttribute('data-answer') === 'quit-cup-quiz') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="show-cups-product"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
      }
     if (this.getAttribute('data-answer') === 'continue-cup-quiz') {
        const cupsQuestionElement = document.querySelector('.quiz-question[data-question="filter"]');
        if (cupsQuestionElement) {
          cupsQuestionElement.style.display = 'flex';
        }
       
      }

    });
  });

});